module.exports = __webpack_public_path__ + "static/img/d5.076dc3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/d5.png
// module id = Pk0Q
// module chunks = 0